import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { TitleBar } from "../components/index.js";
import { getSpells } from "../logic/Logic.js";

import tt_blood_legacy from "../data/tt_blood_legacy.png";
import tt_breeding_pit_grimoire from "../data/tt_breeding_pit_grimoire.png";
import tt_breeding_pits from "../data/tt_breeding_pits.png";
import tt_core from "../data/tt_core.png";
import tt_fireheart from "../data/tt_fireheart.png";
import tt_fireheart_c1 from "../data/tt_fireheart_c1.png";
import tt_fireheart_c2 from "../data/tt_fireheart_c2.png";
import tt_fireheart_c3 from "../data/tt_fireheart_c3_note.png";
import tt_forgotten_pacts from "../data/tt_forgotten_pacts.png";
import tt_forgotten_pacts_ammo from "../data/tt_forgotten_pacts_ammo.png";
import tt_lich_king from "../data/tt_lich_king.png";
import tt_redking from "../data/tt_redking.png";
import tt_wildwoods from "../data/tt_wildwoods.png";
import tt_wildwoods_magic_item from "../data/tt_wildwoods_magic_item.png";
import tt_wildwoods_magic_weapon_and_armor from "../data/tt_wildwoods_magic_weapon_and_armor.png";

const Play = ({}) => {
  const [infos, setInfos] = useState({});

  useEffect(() => {
    list();
  }, []);

  const list = async () => {
    const ret = { spells: getSpells() };
    setInfos(ret);
  };

  return (
    <TitleBar marginLateral={15} showBack={false} titulo={"Play"}>
      <br></br>
      Core
      <img src={tt_core} style={{ maxWidth: 700 }} />
      <br></br>
      Breeding Pits
      <img src={tt_breeding_pits} style={{ maxWidth: 700 }} />
      <br></br>
      Breeding Pit Grimoire
      <img src={tt_breeding_pit_grimoire} style={{ maxWidth: 700 }} />
      <br></br>
      Fireheart
      <img src={tt_fireheart} style={{ maxWidth: 700 }} />
      <br></br>
      Fireheart Construct 1
      <img src={tt_fireheart_c1} style={{ maxWidth: 700 }} />
      <br></br>
      Fireheart Construct 2
      <img src={tt_fireheart_c2} style={{ maxWidth: 700 }} />
      <br></br>
      Fireheart Construct 3
      <img src={tt_fireheart_c3} style={{ maxWidth: 700 }} />
      <br></br>
      Lich King
      <img src={tt_lich_king} style={{ maxWidth: 700 }} />
      <br></br>
      Red King
      <img src={tt_redking} style={{ maxWidth: 700 }} />
      <br></br>
      Blood Legacy
      <img src={tt_blood_legacy} style={{ maxWidth: 700 }} />
      <br></br>
      Forgotten Pacts
      <img src={tt_forgotten_pacts} style={{ maxWidth: 700 }} />
      <br></br>
      Forgotten Pacts Ammo
      <img src={tt_forgotten_pacts_ammo} style={{ maxWidth: 700 }} />
      <br></br>
      Wildwoods
      <img src={tt_wildwoods} style={{ maxWidth: 700 }} />
      <br></br>
      Wildwoods Magic Item
      <img src={tt_wildwoods_magic_item} style={{ maxWidth: 700 }} />
      <br></br>
      Wildwoods Magic Weapon and Armor
      <img src={tt_wildwoods_magic_weapon_and_armor} style={{ maxWidth: 700 }} />
      <br></br>
    </TitleBar>
  );
};

const mapStateToProps = (state) => ({
  user: state.Reducer.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Play);
